// extracted by mini-css-extract-plugin
module.exports = {"container":"ListWrapper_container__3rPtW px-7","content":"ListWrapper_content__55bUI pt-9 pb-7","body":"ListWrapper_body__tdmVD mt-9"};